import { ArsTableTreeNodeProps } from "../ArsTableTreeNode";
import {
  ArsTableGroupCalculationDto,
  ArsTableOperation,
  ArsTableSubGroupAnalysisMethod,
  ArsTableSubGroupGroup,
  ArsTableSubGroupGroupingFactor,
} from "../interface";

/**
 * Converts an ArsTableGroup into a tree node structure.
 *
 * @param group - The group to convert
 * @param isT - A type guard function for the generic type T used in the group label
 * @returns Tree node representation
 */
export const groupToTreeNode = <T>(
  group: ArsTableGroupCalculationDto<T>,
  isT: (obj: unknown) => obj is T,
): ArsTableTreeNodeProps<T> => {
  // SubGroup node
  const children = (group.subGroups ?? []).map((g) => groupToTreeNode(g, isT));

  if ("groupingFactor" in group) {
    const sggf = group as ArsTableSubGroupGroupingFactor<T>;
    return {
      id: sggf.id,
      label: sggf.label,
      type: "groupingFactor",
      subNodes: children.length > 0 ? children : undefined,
    };
  } else if ("group" in group) {
    const sgg = group as ArsTableSubGroupGroup<T>;
    return {
      id: sgg.id,
      label: sgg.label,
      type: "group",
      subNodes: children.length > 0 ? children : undefined,
    };
  } else if ("operation" in group) {
    const op = group as ArsTableOperation<T>;
    return {
      id: op.id,
      label: op.label,
      type: "operation",
      subNodes: children.length > 0 ? children : undefined,
    };
  } else {
    const sgam = group as ArsTableSubGroupAnalysisMethod<T>;
    return {
      id: sgam.id,
      label: sgam.label,
      type: "analysisMethod",
      subNodes: children.length > 0 ? children : undefined,
    };
  }
};
